// extracted by mini-css-extract-plugin
export var alternate = "_17-h";
export var black = "_17-3";
export var blue = "_17-d";
export var blueLight = "_17-c";
export var brand = "_17-7";
export var error = "_17-9";
export var gray = "_17-6";
export var grayBlue = "_17-b";
export var iconWrapper = "_17-4";
export var indigo = "_17-e";
export var orange = "_17-g";
export var pink = "_17-f";
export var primary = "_17-0";
export var purple = "_17-8";
export var success = "_17-5";
export var warning = "_17-a";
export var white = "_17-1";
export var whiteSuccess = "_17-2";